<ng-container *ngFor="let ayaSchoolTable of ayaSchoolTables$ | async">
  <div class="aya-data__section">
    <lx-price-lists-portal-aya-summary [language]="ayaSchoolTable.language" [year]="currentYear$ | async"></lx-price-lists-portal-aya-summary>
  </div>
  <div class="aya-data__section">
    <lx-price-lists-portal-aya-countries-school-list [schoolTables]="ayaSchoolTable.schoolsByCountryTable"></lx-price-lists-portal-aya-countries-school-list>
  </div>
  <div class="aya-data__section">
    <lx-price-lists-portal-aya-extra-info [schoolTables]="ayaSchoolTable.schoolsByCountryTable"></lx-price-lists-portal-aya-extra-info>
  </div>
</ng-container>
